/**
 * Klucz localStorage z momentem (ms), do którego popup Autoreklamy jest ukryty.
 * Osobny plik bez zależności od Reacta i Firebase, bo importują go też testy E2E (Node).
 */
export const AUDIT_AD_HIDDEN_UNTIL_KEY = 'hs_audit_ad_hidden_until';
